export const LOADING_HISTORICO_RESERVAS = 'LOADING_HISTORICO_RESERVAS'

export const LOADING_PROVEEDORES_RESERVAS = 'LOADING_PROVEEDORES_RESERVAS'

export const GET_PROVEEDORES_RESERVAS = 'GET_PROVEEDORES_RESERVAS'

export const SET_PROVEEDORES_RESERVAS = 'SET_PROVEEDORES_RESERVAS'

export const SET_PROVEEDOR_SELECT = 'SET_PROVEEDOR_SELECT'

export const GET_HISTORY_RESERVAS = 'GET_HISTORY_RESERVAS'

export const SET_HISTORY_RESERVAS = 'SET_HISTORY_RESERVAS'

export const CLEAR_FILTROS_RESERVAS = 'CLEAR_FILTROS_RESERVAS'

export const SET_ORDEN_PEDIDO = 'SET_ORDEN_PEDIDO'

export const SET_DATASTATE = 'SET_DATASTATE'

export const SET_TIPO_RESERVA = 'SET_TIPO_RESERVA'

export const SET_DATE_FILTER = 'SET_DATE_FILTER'

export const CLEAR_DATE_FILTER = 'CLEAR_DATE_FILTER'

export const RESET_GRID_KEY = 'RESET_GRID_KEY'
